export const NAME = 'ProdejPult';
